import { Grid, Typography } from "@mui/material";
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import { useTranslation } from 'react-i18next';
import { appStyleMode } from "../../helpers/clientConfigs";
import { AppStyle } from "../../helpers/appStyle";

export function NoElements() {
  const { t } = useTranslation('services');

  return (
    <Grid container justifyContent="center" alignItems="center" direction="column"
      sx={{
        my: "10px",
        backgroundColor: "white",
        borderRadius: "15px",
        height: appStyleMode !== AppStyle.Mobile && "600px"
      }}>
      <Typography color="gray" fontSize="20px">{t('empty')}</Typography>
      <SentimentDissatisfiedIcon
        sx={{
          color: "gray",
          height: "100px",
          width: "100px"
        }} />
    </Grid>
  );
}
